module.exports = "/assets/packs/images/2139319e5ada90d124b00300aca62a54.svg";